import request from '@host-panel/request';

export type FindUserByUsernameResponse = {
  suggestions: any[];
};

export function findUserByEmail(email: string): Promise<FindUserByUsernameResponse> {
  return request(`/host-panel/find-user/email`, {
    method: 'GET',
    data: {
      email: encodeURIComponent(email)
    }
  });
}
